import { createSelector } from '@ngrx/store';

import { getUploaderState } from '../uploader/uploader.state';

export const getSettingsState = createSelector(getUploaderState, (state) => state.settings);

export const getAcceptedFileExtensions = createSelector(
  getSettingsState,
  (state) => state.acceptedFileExtensions,
);

export const getIsMultipleSelection = createSelector(
  getSettingsState,
  (state) => state.isMultipleSelection || false,
);

export const getMinimumImageDimensions = createSelector(
  getSettingsState,
  (state) => state.minimumImageDimensions,
);

export const getIsCropForced = createSelector(
  getSettingsState,
  (state) => state.forceCrop === true,
);

export const getCropForceAspectRatio = createSelector(
  getSettingsState,
  (state) => state.cropForceAspectRatio,
);

export const getCropMaximumImageSize = createSelector(
  getSettingsState,
  (state) => state.cropMaximumImageSize,
);

export const getIsSecure = createSelector(getSettingsState, (state) => state.isSecure ?? false);

export const getAccountId = createSelector(getSettingsState, (state) => state.accountId);

export const getProjectId = createSelector(getSettingsState, (state) => state.projectId);

export const getCategory = createSelector(getSettingsState, (state) => state.category);
